import { DEFAULT_WIDTH } from "../../../constants/layout.js";
import { uuid25 } from "../../../uuid/dist/uuid25.js";
import { CanvasType } from "../../../constants/schema.js";
import { arrayHas } from "../../../utils/arrayHas.js";
//#region src/engine/modules/editor/state.ts
var SelectType = {
	table: "table",
	memo: "memo",
	tableGroup: "tableGroup"
};
var ShowMode = {
	nameOnly: "nameOnly",
	keysOnly: "keysOnly",
	allFields: "allFields"
};
var ViewKind = { flow: "flow" };
var VisualizationMode = {
	graph: "graph",
	flow: "flow"
};
var CenterStep = {
	previous: "previous",
	next: "next"
};
var FocusType = {
	tableName: "tableName",
	tableComment: "tableComment",
	columnName: "columnName",
	columnDataType: "columnDataType",
	columnNotNull: "columnNotNull",
	columnUnique: "columnUnique",
	columnAutoIncrement: "columnAutoIncrement",
	columnDefault: "columnDefault",
	columnComment: "columnComment",
	tableLogicalName: "tableLogicalName",
	columnLogicalName: "columnLogicalName",
	columnDomain: "columnDomain"
};
var MoveKey = {
	ArrowUp: "ArrowUp",
	ArrowRight: "ArrowRight",
	ArrowDown: "ArrowDown",
	ArrowLeft: "ArrowLeft",
	Tab: "Tab"
};
var hasMoveKeys = arrayHas(Object.values(MoveKey));
var isEditingMemo = ({ editMemoId }) => Boolean(editMemoId);
var isEditingText = (editor) => isEditingMemo(editor) || Boolean(editor.focusTable?.edit) || Boolean(editor.editTableGroupId);
var createEditor = () => ({
	id: uuid25(),
	selectedMap: {},
	hasUndo: false,
	hasRedo: false,
	dictionaryHistory: {
		word: {
			hasUndo: false,
			hasRedo: false
		},
		term: {
			hasUndo: false,
			hasRedo: false
		},
		domain: {
			hasUndo: false,
			hasRedo: false
		}
	},
	viewport: {
		width: DEFAULT_WIDTH,
		height: 675
	},
	scrollPullPending: false,
	originShown: false,
	focusTable: null,
	editMemoId: null,
	editTableGroupId: null,
	memoScrollTopMap: {},
	drawRelationship: null,
	hoverColumnMap: {},
	hoverRelationshipMap: {},
	openMap: {},
	handTool: false,
	drawTableGroup: false,
	zenMode: false,
	draggableColumn: null,
	draggingColumnMap: {},
	sharedMouseTrackerMap: {},
	sharedFocusTrackerMap: {},
	sharedSelectionTrackerMap: {},
	sharedDragSelectTrackerMap: {},
	dragSelect: null,
	views: { flow: null },
	visualizationMode: VisualizationMode.graph,
	lastCanvasType: CanvasType.ERD,
	screenBaseline: null
});
//#endregion
export { CenterStep, FocusType, MoveKey, SelectType, ShowMode, ViewKind, VisualizationMode, createEditor, hasMoveKeys, isEditingMemo, isEditingText };
